import React, {Component} from 'react'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend';
import {Link} from 'react-router-dom'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx"
import Icon from "../common/icon/icon.component.jsx"


const messages = defineMessages({
    unnamed: {
        id: 'payment.type.listing.unnamed',
        defaultMessage: "Unnamed",
    }
})

class PaymentTypeListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            loading: false,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.refreshSearch()
    }


    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/payment-types').then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="listing.payment_type.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="listing.payment_type.list.headers.description_label"
                defaultMessage="Description"
            />,
            <FormattedMessage
                id="listing.payment_type.list.headers.status_label"
                defaultMessage="Status"
            />,
        ]
    }

    row(item) {
        const status = item.attributes.status === "enabled" ? <div className="badge badge-primary">
            <FormattedMessage
                id="payment_type.listing.status.enabled_label"
                defaultMessage="Enabled"
            />
        </div> : <div className="badge badge-secondary">
            <FormattedMessage
                id="payment_type.listing.status.disabled_label"
                defaultMessage="Disabled"
            />
        </div>

        return [
            <Link
                to={"/payment-types/" + item.id + '/edit'}>{item.attributes.name || this.props.intl.formatMessage(messages.unnamed)}</Link>,
            <span>{item.attributes.description}</span>,
            status,
        ]
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner/>
        }

        return (
            <div>
                <MyAccountTabs/>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-3 text-align-right ">
                                <Link to="/payment-types/new" className="btn btn-primary">
                                    <Icon value={"plus-circle"}/>
                                    <FormattedMessage
                                        id="payment_type.listing.add_payment_type_btn"
                                        defaultMessage="Add payment type"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default injectIntl(PaymentTypeListing)


// WEBPACK FOOTER //
// ./src/payment-type/listing.component.jsx